import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "svg-icon svg-icon-3" }
const _hoisted_2 = {
  class: "card w-100",
  id: "kt_drawer_chat_messenger"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header pe-5",
  id: "kt_drawer_chat_messenger_header"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center flex-column me-3" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1"
      }, "Brian Cox")
    ])
  ])
], -1)
const _hoisted_4 = {
  key: 0,
  class: "me-n5 pe-5",
  ref: "messagesRef"
}
const _hoisted_5 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "card-footer d-flex pt-4",
  id: "kt_drawer_chat_messenger_footer"
}
const _hoisted_8 = { class: "svg-icon svg-icon-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_MessageIn = _resolveComponent("MessageIn")!
  const _component_MessageOut = _resolveComponent("MessageOut")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getMessages && _ctx.getMessages(...args))),
      class: _normalizeClass([_ctx.id, "btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px position-relative"])
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/text/chat.svg" })
      ])
    ], 2),
    _createElementVNode("div", {
      ref: "chatBox",
      id: "kt_drawer_chat",
      class: _normalizeClass(["bg-white drawer drawer-end", { 'drawer-on': _ctx.showMessage, ['drawer' + _ctx.id]: true }]),
      "data-kt-drawer": "true",
      "data-kt-drawer-name": "chat",
      "data-kt-drawer-activate": "true",
      "data-kt-drawer-width": "{default:'500', 'md': '500px'}"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          ref: "messageContainer",
          class: _normalizeClass(["card-body scroll-y", `a${_ctx.id}`])
        }, [
          (_ctx.messageList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.date), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.messgaes, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (item.createdByType === 'customer')
                          ? (_openBlock(), _createBlock(_component_MessageIn, {
                              key: 0,
                              ref_for: true,
                              ref: "messagesInRef",
                              name: item.customerName,
                              time: item.time,
                              text: item.content
                            }, null, 8, ["name", "time", "text"]))
                          : _createCommentVNode("", true),
                        (item.createdByType === 'admin')
                          ? (_openBlock(), _createBlock(_component_MessageOut, {
                              key: 1,
                              ref_for: true,
                              ref: "messagesOutRef",
                              name: item.adminName,
                              time: item.time,
                              text: item.content
                            }, null, 8, ["name", "time", "text"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]))
                }), 128))
              ], 512))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, "There is no message to show"))
        ], 2),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control form-control-flush mb-3",
            "data-kt-element": "input",
            placeholder: "Type a message",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newMessageText) = $event)),
            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.newMessageText]
          ]),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args))),
            class: "btn btn-primary btn-sm d-flex align-items-center justify-content-center",
            type: "button",
            "data-kt-element": "send"
          }, [
            _createTextVNode(" Send "),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen016.svg" })
            ])
          ]),
          _hoisted_9
        ])
      ])
    ], 2)
  ], 64))
}